import DOMPurify from "dompurify";

// ลิงก์ที่เปิดแท็บใหม่ต้องมี rel=noopener กัน tabnabbing
// hook นี้ทำงานหลัง DOMPurify คัดกรอง attribute เสร็จแล้ว
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noopener noreferrer");
  }
});

// ใช้ allowlist มาตรฐานของ DOMPurify ไม่กำหนดเอง
// เพราะที่ Quill สร้างได้ (bold/italic/underline/color/list/link/emoji)
// อยู่ในชุดมาตรฐานอยู่แล้ว การรัดให้แคบลงไม่ได้ปลอดภัยขึ้น
// แต่เสี่ยงตัดเนื้อหาเดิมที่บันทึกไว้ก่อนหน้า
//
// ADD_ATTR: ['target'] — ค่าเริ่มต้นตัด target ทิ้ง ซึ่งทำให้ลิงก์
// ที่ตั้งใจเปิดแท็บใหม่เปลี่ยนพฤติกรรม จึงเปิดกลับมา
const CONFIG = { ADD_ATTR: ["target"] };

const toInput = (html) => (html == null ? "" : String(html));

export const sanitizeHtml = (html) => DOMPurify.sanitize(toInput(html), CONFIG);

// เขียน HTML ที่ผ่านการคัดกรองแล้วลง element
// คืนค่าเป็น DocumentFragment แทนสตริง จึงไม่ต้องแตะ innerHTML เลย
export const renderSanitized = (el, html) => {
  const fragment = DOMPurify.sanitize(toInput(html), {
    ...CONFIG,
    RETURN_DOM_FRAGMENT: true,
  });

  el.textContent = "";
  el.appendChild(fragment);
};

export default sanitizeHtml;
